// import _ from 'lodash';

class SettingsMicroSiteConfigsCtrl {
  constructor($scope, $q, microSiteConfigService, venueService, organizationService, sdkUtils, alertService, modalService, imgixService) {
    this._$scope = $scope;
    this._microSiteConfigService = microSiteConfigService;
    this._organizationService = organizationService;
    this._sdkUtils = sdkUtils;
    this._alertService = alertService;
    this._modalService = modalService;
    this._imgixService = imgixService;

    this.currentUserOrganization = organizationService.getCurrentOrganization();
    this.loading = true;

    $q.all([
        venueService.getCurrentVenues(),
        this.getMicroSiteConfigs()
      ])
      .then(results => {
        this.venues = results[0];
        this.microSiteConfigs = results[1];
        // this.microSiteConfigs = results[1].map(config => {
        //   config.venues = this.getConfigVenues(config.venues);
        //
        //   return config;
        // });

        this.loading = false;
      });
  }

  getMicroSiteConfigs() {
    return this._microSiteConfigService.listByOrganizationId(this.currentUserOrganization.id)
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  getConfigImage(config) {
    if (!config || !config.backgroundImage) return '';

    return this._imgixService.url(config.backgroundImage, {
      width: 60,
      height: 60
    });
  }

  // getConfigVenues(venueIds) {
  //   return _.filter(this.venues, venue => venueIds.indexOf(venue.id) >= 0);
  // }
}

SettingsMicroSiteConfigsCtrl.$inject = [
  '$scope',
  '$q',
  'jsSdk.microSiteConfig',
  'venueService',
  'organizationService',
  'jsSdk.utils',
  'alertService',
  'modalService',
  'jsSdk.imgix'
];

export default SettingsMicroSiteConfigsCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsMicroSiteConfigs/settingsMicroSiteConfigsCtrl.js